module.exports = __webpack_public_path__ + "static/img/baomingBottom.2a731a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baomingBottom.png
// module id = rIZp
// module chunks = 1